import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import "./TermsConditions.css";
import { Helmet } from "react-helmet-async";

const TermsConditions = () => {
  return (
    <>
      <Helmet>
        <title>Skilledition | Terms & Conditions</title>
        <meta
          name="description"
          content="Read the Skilledition Terms & Conditions to understand the rules, responsibilities, and guidelines for using our skill-based learning platform."
        />
        <link rel="canonical" href="https://skilledition.in/terms" />

        {/* Open Graph */}
        <meta property="og:title" content="Skilledition | Terms & Conditions" />
        <meta
          property="og:description"
          content="Understand the rules, responsibilities, and guidelines for using Skilledition's platform."
        />
        <meta property="og:url" content="https://skilledition.in/terms" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://skilledition.in/seo-banner-terms.png"
        />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          property="twitter:title"
          content="Skilledition | Terms & Conditions"
        />
        <meta
          name="twitter:description"
          content="Understand the rules, responsibilities, and guidelines for using Skilledition's platform."
        />
        <meta
          name="twitter:image"
          content="https://skilledition.in/seo-banner-terms.png"
        />
      </Helmet>

      <section className="terms-condition-section">
        <Container>
          <Row>
            <Col>
              <h2 className="terms-condition-title">Terms & Conditions</h2>
              <p className="terms-condition-subtitle">
                Please read these terms and conditions carefully before using
                Skilledition. By continuing, you agree to abide by all rules and
                policies mentioned below.
              </p>
            </Col>
          </Row>

          <Row>
            <Col md={12}>
              <Card className="terms-condition-card">
                <Card.Body>
                  <h4 className="terms-condition-heading">1. Introduction</h4>
                  <p className="terms-condition-text">
                    By accessing and using Skilledition, you agree to be bound
                    by these Terms & Conditions. If you do not agree, you should
                    not use this platform. These terms apply to all users,
                    including students, instructors, and administrators.
                  </p>

                  <h4 className="terms-condition-heading">
                    2. User Responsibilities
                  </h4>
                  <p className="terms-condition-text">
                    Users are required to provide accurate personal details,
                    maintain account confidentiality, and use Skilledition
                    ethically. Misuse, such as sharing login credentials or
                    engaging in disruptive behavior, may result in suspension or
                    permanent removal of account access.
                  </p>
                  <p className="terms-condition-text">
                    Users must also comply with all applicable laws and refrain
                    from posting offensive, abusive, or misleading content on
                    the platform.
                  </p>

                  <h4 className="terms-condition-heading">3. Course Access</h4>
                  <p className="terms-condition-text">
                    Once enrolled, students are granted access to purchased
                    courses. Access duration may vary depending on the course
                    type. Sharing, reselling, or redistributing course materials
                    without permission is strictly prohibited and may lead to
                    legal action.
                  </p>

                  <h4 className="terms-condition-heading">
                    4. Payments & Refunds
                  </h4>
                  <p className="terms-condition-text">
                    All payments must be completed through authorized payment
                    gateways. Fees are non-transferable. Refunds, if applicable,
                    will be processed according to our refund policy and will
                    only be granted under valid circumstances (e.g., duplicate
                    payments, technical issues preventing access).
                  </p>

                  <h4 className="terms-condition-heading">
                    5. Assignments & Certificates
                  </h4>
                  <p className="terms-condition-text">
                    Students must complete assignments with integrity.
                    Plagiarism or dishonest practices will result in
                    disqualification. Certificates of completion will only be
                    issued after successfully finishing all required modules and
                    assessments.
                  </p>

                  <h4 className="terms-condition-heading">
                    6. Intellectual Property
                  </h4>
                  <p className="terms-condition-text">
                    All content on Skilledition, including videos, lectures,
                    PDFs, quizzes, and graphics, is the intellectual property of
                    our platform or respective instructors. Users may not copy,
                    distribute, or modify content without prior written consent.
                  </p>

                  <h4 className="terms-condition-heading">
                    7. Privacy & Data Protection
                  </h4>
                  <p className="terms-condition-text">
                    We respect your privacy and protect your personal data in
                    accordance with applicable laws. Information collected will
                    only be used to improve your learning experience. We do not
                    share your data with third parties unless required by law.
                  </p>

                  <h4 className="terms-condition-heading">
                    8. Third-Party Services
                  </h4>
                  <p className="terms-condition-text">
                    Skilledition may integrate with third-party tools (e.g.,
                    video conferencing, payment providers). We are not
                    responsible for the practices, policies, or reliability of
                    third-party services. Users are encouraged to review their
                    policies separately.
                  </p>

                  <h4 className="terms-condition-heading">
                    9. Limitation of Liability
                  </h4>
                  <p className="terms-condition-text">
                    While we strive to provide uninterrupted services, we are
                    not liable for disruptions caused by technical failures,
                    internet issues, or events beyond our control. Our liability
                    is limited to the extent permitted by law.
                  </p>

                  <h4 className="terms-condition-heading">
                    10. Termination of Access
                  </h4>
                  <p className="terms-condition-text">
                    We reserve the right to suspend or terminate user accounts
                    without prior notice if any violation of these terms is
                    detected. Upon termination, users will lose access to all
                    enrolled courses and resources.
                  </p>

                  <h4 className="terms-condition-heading">11. Governing Law</h4>
                  <p className="terms-condition-text">
                    These Terms & Conditions shall be governed by and construed
                    in accordance with the laws of India. Any disputes shall
                    fall under the jurisdiction of the local courts of Andhra
                    Pradesh.
                  </p>

                  <h4 className="terms-condition-heading">12. Contact Us</h4>
                  <p className="terms-condition-text">
                    For any questions, support requests, or clarifications
                    regarding these Terms & Conditions, you can contact us at:
                    <br /> 📧 Email: info@skilledition.in
                    <br /> 📞 Phone: +91 8143 8796 27 
                    <br /> 🏢 Address: Digisphere Tech Pvt. Ltd, Vijayawada,
                    India
                  </p>

                  <p className="terms-condition-footer">
                    By continuing to use Skilledition, you acknowledge that you
                    have read, understood, and agreed to these Terms &
                    Conditions.
                  </p>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default TermsConditions;
